var keys = {
    NOT_allNotifications: "NOT_allNotifications",
    NOT_archivedNotifications: "NOT_archivedNotifications",
    NOT_closeButtonTooltip: "NOT_closeButtonTooltip",
    NOT_archiveAllBtn: "NOT_archiveAllBtn",
    NOT_noNewNotifications: "NOT_noNewNotifications",
    NOT_clientAdded: "NOT_clientAdded",
    NOT_clientAddedWithMigrationDate: "NOT_clientAddedWithMigrationDate",
    NOT_rejectionReason: "NOT_rejectionReason",
    NOT_alreadyApproved: "NOT_alreadyApproved",
    NOT_apiKeyRecommendation: "NOT_apiKeyRecommendation",
    NOT_generateNewAPIKey: "NOT_generateNewAPIKey",
    NOT_partnerRequestFailed: "NOT_partnerRequestFailed",
    NOT_partnerRequestCancelled: "NOT_partnerRequestCancelled",
    NOT_needCaptcha: "NOT_needCaptcha",
    NOT_errorUpdatingChatSupport: "NOT_errorUpdatingChatSupport",
    NOT_approved: "NOT_approved",
    NOT_pending: "NOT_pending",
    NOT_affectedNumbers: "NOT_affectedNumbers",
    NOT_emptyStateMessage: "NOT_emptyStateMessage",
    NOT_allNumbersAffected: "NOT_allNumbersAffected",
    NOT_viewGuide: "NOT_viewGuide",
    NOT_techProviderActionRequired: "NOT_techProviderActionRequired",
    NOT_techProviderActionRequiredDesc: "NOT_techProviderActionRequiredDesc",
    NOT_limitReached: "NOT_limitReached",
    NOT_canOnboardOne: "NOT_canOnboardOne",
    NOT_canOnboardCount: "NOT_canOnboardCount",
    WAP_text: "WAP_text",
    WAP_cta: "WAP_cta",
    WAP_dismiss: "WAP_dismiss",
};
export default keys;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImtleXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBTSxJQUFJLEdBQTRCO0lBQ2xDLG9CQUFvQixFQUFFLHNCQUFzQjtJQUM1Qyx5QkFBeUIsRUFBRSwyQkFBMkI7SUFDdEQsc0JBQXNCLEVBQUUsd0JBQXdCO0lBQ2hELGlCQUFpQixFQUFFLG1CQUFtQjtJQUN0QyxzQkFBc0IsRUFBRSx3QkFBd0I7SUFDaEQsZUFBZSxFQUFFLGlCQUFpQjtJQUNsQyxnQ0FBZ0MsRUFBRSxrQ0FBa0M7SUFDcEUsbUJBQW1CLEVBQUUscUJBQXFCO0lBQzFDLG1CQUFtQixFQUFFLHFCQUFxQjtJQUMxQyx3QkFBd0IsRUFBRSwwQkFBMEI7SUFDcEQscUJBQXFCLEVBQUUsdUJBQXVCO0lBQzlDLHdCQUF3QixFQUFFLDBCQUEwQjtJQUNwRCwyQkFBMkIsRUFBRSw2QkFBNkI7SUFDMUQsZUFBZSxFQUFFLGlCQUFpQjtJQUNsQyw0QkFBNEIsRUFBRSw4QkFBOEI7SUFDNUQsWUFBWSxFQUFFLGNBQWM7SUFDNUIsV0FBVyxFQUFFLGFBQWE7SUFDMUIsbUJBQW1CLEVBQUUscUJBQXFCO0lBQzFDLHFCQUFxQixFQUFFLHVCQUF1QjtJQUM5QyxzQkFBc0IsRUFBRSx3QkFBd0I7SUFDaEQsYUFBYSxFQUFFLGVBQWU7SUFDOUIsOEJBQThCLEVBQUUsZ0NBQWdDO0lBQ2hFLGtDQUFrQyxFQUFFLG9DQUFvQztJQUN4RSxnQkFBZ0IsRUFBRSxrQkFBa0I7SUFDcEMsaUJBQWlCLEVBQUUsbUJBQW1CO0lBQ3RDLG1CQUFtQixFQUFFLHFCQUFxQjtJQUMxQyxRQUFRLEVBQUUsVUFBVTtJQUNwQixPQUFPLEVBQUUsU0FBUztJQUNsQixXQUFXLEVBQUUsYUFBYTtDQUMzQixDQUFDO0FBRUYsZUFBZSxJQUFJLENBQUMifQ==